import React from "react";
import DOMPurify from "dompurify";

export default function CompanyHighlights({ data }) {
  if (!data || data.length === 0) return null;

  return (
    <div style={{ marginTop: "30px", marginBottom: "30px" }}>
      <h2 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "20px" }}>
        {/* ✨ Highlights */}
      </h2>

      <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        {data.map((highlight, index) => (
          <div
            key={index}
            style={{
              padding: "20px",
              background: "white",
              borderRadius: "10px",
              border: "1px solid #e5e7eb"
            }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(highlight)
            }}
          />
        ))}
      </div>
    </div>
  );
}
